import { TextBox, TextBoxTypes } from 'atoms/TextBox'
import { Colors, TextAligning } from 'atoms/TextBox/TextBox.h'
import { ToggleSwitch } from 'atoms/ToggleSwitch'
import { ToggleItemSC } from './ToggleItem.styled'

interface ISettingsMenuProps {
  checked: boolean
  onChange?: (isChecked: boolean) => void
  title?: string
  font?: TextBoxTypes
}

export const ToggleItem = ({
  title = '',
  checked,
  onChange,
  font = TextBoxTypes.FontSmBold,
}: ISettingsMenuProps) => {
  return (
    <ToggleItemSC>
      <TextBox
        title={title}
        color={Colors.TEXT_ICON_PRIMARY}
        font={font}
        alignment={TextAligning.Left}
        maxLines={1}
      />
      <ToggleSwitch checked={checked} onChange={onChange} />
    </ToggleItemSC>
  )
}
